import { render, staticRenderFns } from "./ui-period-picker.vue?vue&type=template&id=6c0a358a&scoped=true&"
import script from "./ui-period-picker.vue?vue&type=script&lang=ts&"
export * from "./ui-period-picker.vue?vue&type=script&lang=ts&"
import style0 from "./ui-period-picker.vue?vue&type=style&index=0&id=6c0a358a&lang=scss&scoped=true&"
import style1 from "./ui-period-picker.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a358a",
  null
  
)

export default component.exports